import Vue from 'vue'

export default Vue.extend({
  name: 'IconSuccess',
  functional: true,
  render(h) {
    return h(
      'svg',
      {
        staticClass: 'app-alert__icon',
        attrs: { viewBox: '0 -960 960 960' },
      },
      [
        h('path', {
          attrs: {
            d: 'm424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31t-127-86q-54-54-85-127T80-480q0-83 32-156t85-127q54-54 127-85t156-32q83 0 156 32t127 85q54 54 86 127t31 156q0 83-31 156t-86 127q-54 54-127 86T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z',
          },
        }),
      ],
    )
  },
})
